import React from 'react'
import { WidgetContextHolder } from '@typesApp/WidgetContextHolder'
import { AppWithConfigurationHOC, AppWithConfigurationProps } from './AppHOC'

const MyClaims = React.lazy(() => import('@components/MyClaims/MyClaims'))

type LegacyShoppingAction = {
  ctaLabel: string
  onClick: () => void
}

type MyClaimsAppProps = AppWithConfigurationProps & {
  shoppingActions: LegacyShoppingAction[]
  onOrderClick: (orderNumber: string) => void
}

export const MyClaimsApp: React.FC<MyClaimsAppProps> = props => {
  const { customerContext: customer, actionModule, environment, widgetContext, shoppingActions, onOrderClick } = props

  // NOTE: map legacy props until existing brands migrate to use widgetContext
  const context = widgetContext ?? getWidgetContextFromLegacyProps(shoppingActions, onOrderClick)

  return (
    <AppWithConfigurationHOC
      customerContext={customer}
      environment={environment}
      actionModule={actionModule}
      widgetContext={context}
    >
      <MyClaims />
    </AppWithConfigurationHOC>
  )
}

const getWidgetContextFromLegacyProps = (
  legacyActions: LegacyShoppingAction[],
  onOrderClick: (orderNumber: string) => void
): WidgetContextHolder => {
  const actions = legacyActions && Array.isArray(legacyActions) ? legacyActions : []
  const shoppingActions = actions.map(action => ({ label: action.ctaLabel, onClick: action.onClick }))

  return {
    myClaims: {
      shoppingActions,
      onOrderClick,
    },
  }
}
